import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {

  },
  mutations: {
    SET_NOTIFICATIONS(state, notifications) {
      state.data = notifications;
    }
  },
  actions: {
    async fetchNotification({ commit, state }) {

      //commit('RESET_STATE');

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/push/');
        commit('SET_DATA', {data:response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    notification: state => state.data,
    notificationLoading: state => state.loading,
    notificationError: state => state.error,
    notificationLoaded: state => state.loaded,
  }
})